import firebase from 'firebase/app';
import 'firebase/auth';

//export function googleLogin() {

  const firebaseConfig = {
    apiKey: "AIzaSyDGW1BIhAjuNXmpFua933PjKa3xJ0e-LH8",
    authDomain: "miraplay-d00fa.firebaseapp.com",
    projectId: "miraplay-d00fa",
    storageBucket: "miraplay-d00fa.firebasestorage.app",
    messagingSenderId: "309478502692",
    appId: "1:309478502692:web:051a3a86bc4667a84003b1",
    measurementId: "G-VJ8MVDQ16D"
  }
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig)
  }
  // 导出 auth 和 Google 提供者
  export const googleAuth = firebase.auth();
  export const googleProvider = new firebase.auth.GoogleAuthProvider();
  export const appleProvider = new firebase.auth.OAuthProvider('apple.com');

  googleProvider.setCustomParameters({
    prompt: 'select_account',  // 总是显示账户选择
    login_hint: '',           // 可以预填邮箱
  });
  //firebase.initializeApp(firebaseConfig);
  //const appCheck = firebase.appCheck();
  // appCheck.activate(
  //   new firebase.appCheck.ReCaptchaEnterpriseProvider("6LcNQU4rAAAAAId7mAuFZvyQYxn7DwkFp_2Yqbk5"),
  //   true // Set to true to allow auto-refresh.
  // );
  // const provider = new firebase.auth.GoogleAuthProvider();
  // console.log("Firebase 版本:", firebase.SDK_VERSION);
  // console.log("GoogleAuthProvider 是否存在?", !!firebase.auth.GoogleAuthProvider);
  // alert("111");
  // firebase.auth().signInWithPopup(provider)
  //   .then((result) => {
  //     // 处理登录成功的情况
  //     alert("222");
  //     const credential = GoogleAuthProvider.credentialFromResult(result);
  //     const token = credential.accessToken;
  //     // The signed-in user info.
  //     const user = result.user;
  //     console.log('已登录的用户信息：',user)
  //   })
  //   .catch((error) => {
  //     // 处理登录失败的情况
  //     alert(error.message);
  //     const errorCode = error.code;
  //     const errorMessage = error.message;
  //     console.log('已登录的用户信息：',errorMessage)
  //     // 使用的用户帐户的电子邮件。
  //     //const email = error.customData.email;
  //     // 使用的AuthCredential类型。
  //     //const credential = GoogleAuthProvider.credentialFromError(error);
  //   });
//}



// WEBPACK FOOTER //
// ./src/utils/googleLogin.js